























import { OnSubmitInput } from '@/main-components/common/Form.vue';
import Input from '@/main-components/common/Input.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: { MainButton, Input },
})
export default class BlogSearch extends Vue {
  @Prop()
  keyword: string;

  keywordInput = '';
  submitInput: (() => Promise<OnSubmitInput>) | null = null;

  created() {
    this.keywordInput = this.keyword;
  }

  addSubmitInput(submitInput: any) {
    if (submitInput) {
      this.submitInput = submitInput;
    }
  }

  async submitSearch() {
    this.$sendMpEvent({ event: this.$mp_value.BlogSearch });
    const inputResult = this.submitInput && (await this.submitInput());
    this.keywordInput = (inputResult && (inputResult.value as string)) || '';
    this.$emit('refetchBlogs', this.keywordInput);
    return;
  }
}
